export var ApiRateLimitCostEnum;
(function (ApiRateLimitCostEnum) {
    ApiRateLimitCostEnum["SINGLE"] = "single";
    ApiRateLimitCostEnum["BULK"] = "bulk";
})(ApiRateLimitCostEnum || (ApiRateLimitCostEnum = {}));
